var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "testimonial-row" }, [
    _c("div", { staticClass: "container" }, [
      _c("h3", { staticClass: "mb-40" }, [_vm._v(_vm._s(_vm.title))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "testimonialsWrapper",
        staticClass: "testimonials-wrapper",
        class: {
          "hide-navigation": !_vm.navigationVisible,
          "container little-items": this.testimonials.length <= 2
        }
      },
      [
        _c("div", { staticClass: "prev control", on: { click: _vm.previous } }),
        _vm._v(" "),
        _c("div", { staticClass: "d-none d-lg-block" }, [
          _c(
            "div",
            {
              ref: "center",
              staticClass: "center-wrapper d-flex",
              class: { even: this.testimonials.length % 2 === 0 }
            },
            [
              _c(
                "div",
                {
                  staticClass: "left-wrapper d-flex",
                  class: { "flex-row-reverse": this.testimonials.length <= 2 }
                },
                _vm._l(_vm.leftTestimonials, function(testimonial) {
                  return _c(
                    "div",
                    {
                      key: testimonial.id,
                      staticClass: "image-wrapper",
                      class: { active: testimonial === _vm.activeTestimonial },
                      style: { width: _vm.imageWidth },
                      on: {
                        click: function($event) {
                          return _vm.sortTestimonials(testimonial.id)
                        }
                      }
                    },
                    [
                      _c("transition", { attrs: { name: "fade" } }, [
                        _c("img", {
                          attrs: {
                            src: testimonial.acf.images[0].sizes.medium_large,
                            alt: testimonial.post_title
                          }
                        })
                      ])
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content-wrapper px-40" },
                [
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.activeTestimonial != null
                      ? _c(
                          "div",
                          {
                            key: _vm.activeTestimonial.id,
                            staticClass:
                              "d-flex align-items-start flex-column justify-content-center"
                          },
                          [
                            _c("blockquote", { staticClass: "mb-24" }, [
                              _vm._v(_vm._s(_vm.activeTestimonial.acf.quote))
                            ]),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "d-block author font-weight-light",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.activeTestimonial.post_title
                                )
                              }
                            }),
                            _vm._v(" "),
                            _vm.activeTestimonial.acf.story != null &&
                            _vm.activeTestimonial.acf.story.length > 0
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-accent mt-24",
                                    attrs: {
                                      href: _vm.route("nl.story", {
                                        slug:
                                          _vm.activeTestimonial.acf.story[0]
                                            .post_name
                                      })
                                    }
                                  },
                                  [_vm._v("Lees het verhaal")]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right-wrapper d-flex" },
                _vm._l(_vm.rightTestimonials, function(testimonial) {
                  return _c(
                    "div",
                    {
                      key: testimonial.id,
                      staticClass: "image-wrapper",
                      style: { width: _vm.imageWidth },
                      on: {
                        click: function($event) {
                          return _vm.sortTestimonials(testimonial.id)
                        }
                      }
                    },
                    [
                      _c("transition", { attrs: { name: "fade" } }, [
                        _c("img", {
                          attrs: {
                            src: testimonial.acf.images[0].sizes.medium_large,
                            alt: testimonial.post_title
                          }
                        })
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-lg-none" }, [
          _c(
            "div",
            {
              ref: "imageCarousel",
              staticClass: "image-carousel mb-40",
              class: { single: this.testimonials.length === 1 }
            },
            [
              _c(
                "div",
                {
                  ref: "mobileCenter",
                  staticClass: "center-wrapper d-flex",
                  class: { even: this.testimonials.length % 2 === 0 }
                },
                _vm._l(_vm.allSortedTestimonials, function(testimonial) {
                  return _c(
                    "div",
                    {
                      key: testimonial.id,
                      staticClass: "image-wrapper",
                      class: { active: testimonial === _vm.activeTestimonial },
                      style: { width: _vm.imageWidth },
                      on: {
                        click: function($event) {
                          return _vm.sortTestimonials(testimonial.id)
                        }
                      }
                    },
                    [
                      _c("transition", { attrs: { name: "fade" } }, [
                        _c("img", {
                          attrs: {
                            src: testimonial.acf.images[0].sizes.medium_large,
                            alt: testimonial.post_title
                          }
                        })
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { class: { container: this.testimonials.length > 2 } }, [
            _vm.activeTestimonial != null
              ? _c(
                  "div",
                  {
                    key: _vm.activeTestimonial.id,
                    staticClass:
                      "d-flex align-items-start flex-column justify-content-center"
                  },
                  [
                    _c("blockquote", { staticClass: "mb-24" }, [
                      _vm._v(_vm._s(_vm.activeTestimonial.acf.quote))
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "d-block author font-weight-light",
                      domProps: {
                        innerHTML: _vm._s(_vm.activeTestimonial.post_title)
                      }
                    }),
                    _vm._v(" "),
                    _vm.activeTestimonial.acf.story != null &&
                    _vm.activeTestimonial.acf.story.length > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "btn btn-accent mt-40 mt-lg-24",
                            attrs: {
                              href: _vm.route("nl.story", {
                                slug:
                                  _vm.activeTestimonial.acf.story[0].post_name
                              })
                            }
                          },
                          [_vm._v("Lees het verhaal")]
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "next control", on: { click: _vm.next } })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }